export enum Environments {
  PROD = 'hipaa-production',
  STAGING = 'hipaa-staging',
  DEV = 'platform-development',
}

export const BASE_URL: Record<string, string> = {
  [Environments.DEV]: 'https://helix-builder.development.helix.com',
  [Environments.PROD]: 'https://helix-builder.helix.com',
  [Environments.STAGING]: 'https://helix-builder.staging.helix.com',
};

export const isMinifyEnabled = (env: string): boolean => {
  if (env === Environments.PROD || env === Environments.STAGING || env === Environments.DEV) {
    return true;
  }

  return false;
};

export const isSourceMapEnabled = (env: string): boolean | 'inline' | 'hidden' | undefined => {
  if (env === Environments.PROD || env === Environments.STAGING) {
    return 'hidden';
  }

  return true;
};

export const getBaseUrl = (env: string): string => {
  return BASE_URL[env] ?? '';
};
